import inquiryQueries from '@apis/queries/inquiryQueries';
import { useQuery } from '@tanstack/react-query';

function useInquiry(inquiryId: string) {
    const { data: inquiry, ...rest } = useQuery(inquiryQueries.detail(inquiryId));
    return { inquiry, ...rest };
}

export default useInquiry;
